<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Service Areas Single</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        In the same state or in nearby states, add a zipcode you would like to service.
    </ion-list-header>

    <ion-list lines="none">
        <form name="form" (ngSubmit)="f.form.valid && onSaveClick(f)" #f="ngForm" novalidate>
            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">State</ion-label>
                <ion-input color="secondary" type="text" name="state" #state="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && state.invalid }" required [(ngModel)]="area.regionName"
                    id="state" data-test="state">
                </ion-input>
                <ion-buttons class="itemButtons" slot="end">
                    <ion-button class="itemButton" color="primary" expand="full" fill="solid" id="eye"
                        (click)="onStateClick()" data-test="stateBtn">
                        <ion-icon name="search"></ion-icon>
                    </ion-button>
                </ion-buttons>
                @if (submitted && state.invalid) {
                <div>
                    <div class="validationErrorMsg">State is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Zipcode</ion-label>
                <ion-input color="secondary" type="text" name="zipcode" #zipcode="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && zipcode.invalid }" required [(ngModel)]="area.zipcode"
                    id="zipcode" (ionChange)="onZipcodeChange()" data-test="zipcode">  <!-- autofocus="true" -->
                </ion-input>
                <!-- submitted= {{submitted}} zipcode.invalid= {{zipcode.invalid}}<br /> -->
                @if (submitted && zipcode.invalid) {
                <div>
                    <div class="validationErrorMsg">Five digits are required for Zipcode.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">City</ion-label>
                <ion-input color="secondary" type="text" name="city" #city="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && city.invalid }" required [(ngModel)]="area.city" id="city"
                    data-test="city">
                </ion-input>
                @if (submitted && city.invalid) {
                <div>
                    <div class="validationErrorMsg">City is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Distance In Miles</ion-label>
                <ion-input color="secondary" type="number" name="distance" #distance="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && distance.invalid }" required data-test="distance"
                    [(ngModel)]="area.distance" id="city">
                </ion-input>
                @if (submitted && distance.invalid) {
                <div>
                    <div class="validationErrorMsg">Enter the distance from the center of the zipcode to the dealership.
                    </div>
                </div>
                }
            </ion-item>
        </form>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button color="primary" expand="full" (click)="onSaveClick(f)" data-test="saveSingleBtn">Save</ion-button>
    </ion-toolbar>
</ion-footer>